import { render } from "./contextual-help.vue?vue&type=template&id=371dbdc5&ts=true"
import script from "./contextual-help.vue?vue&type=script&lang=ts"
export * from "./contextual-help.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__